import axios from 'axios';

import { toApiDateTime } from '../utils/dateUtils';

const API_URL = process.env.REACT_APP_API_URL;

const createLeaveRequest = async ({ labourer, status = 'Pending', reason, startDate, endDate }) => {
  const { data: leaveRequest } = await axios.post(`${API_URL}/leave-requests`, {
    labourer,
    status,
    reason,
    startDate: toApiDateTime(startDate),
    endDate: toApiDateTime(endDate)
  });

  return { leaveRequest };
};

const getLeaveRequests = async ({ labourerId, page = 1, perPage = 10 }) => {
  const searchParams = new URLSearchParams();

  if (labourerId) searchParams.append('labourerId', labourerId);
  if (page) searchParams.append('page', page);
  if (perPage) searchParams.append('perPage', perPage);

  const params = searchParams.toString();

  const { data: { leaveRequests, count, pages } } = await axios.get(`${API_URL}/leave-requests?${params}`);

  return { leaveRequests, count, pages };
};

const updateLeaveRequest = async ({ leaveRequestId, updateData }) => {
  const { data: leaveRequest } = await axios.put(`${API_URL}/leave-requests/${leaveRequestId}`, updateData);

  return { leaveRequest };
};

const approveLeaveRequest = async (leaveRequestId) => {
  const { data: leaveRequest } = await axios.put(`${API_URL}/leave-requests/${leaveRequestId}/approve`);

  return { leaveRequest };
};

const rejectLeaveRequest = async (leaveRequestId) => {
  const { data: leaveRequest } = await axios.put(`${API_URL}/leave-requests/${leaveRequestId}/reject`);

  return { leaveRequest };
};

const leaveRequestService = {
  createLeaveRequest,
  getLeaveRequests,
  updateLeaveRequest,
  approveLeaveRequest,
  rejectLeaveRequest
};

export default leaveRequestService;
